export const blockExplorers: Record<number, string> = {
  1: "https://etherscan.io/",
  5: "https://goerli.etherscan.io/",
  11155111: "https://sepolia.etherscan.io/",
  42161: "https://arbiscan.io/",
};
